module.exports = __webpack_public_path__ + "static/media/al.c521e40e.svg";